import Cookies from "js-cookie";
import {
  makeRequestDelete2,
  makeRequestGet2,
  makeRequestPost2,
  makeRequestPut2,
} from "../api";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getEquipments() {
  let token = await getToken();
  return makeRequestGet2(`equipments/`, token);
}

export async function getEquipment(id) {
  let token = await getToken();
  return makeRequestGet2(`equipments/${id}`, token);
}

export async function postEquipment(data) {
  let token = await getToken();
  return makeRequestPost2(`equipments/`, data, token);
}

export async function putEquipment(id, data) {
  let token = await getToken();
  return makeRequestPut2(`equipments/${id}`, data, token);
}

export async function deleteEquipment(id, data) {
  let token = await getToken();
  return makeRequestDelete2(`equipments/${id}`, data, token);
}

export async function getEquipmentsByPeriod(data) {
  let token = await getToken();
  return makeRequestPost2(`equipments/equipmentsperiod`, data, token);
}
